import React from 'react';
import { translate } from '../Services/translation';

const ProductTags = (props) => {
    const { isEnvironmentalFriendly, isCampaignProduct } = props;

    return (
        <div>
            {isEnvironmentalFriendly && (
                <svg className="image-tag image-tag--env" data-tip={translate('product.environmentalfriendly.hover')}>
                    <use href="/ui/images/sprites/be-group.svg#environmental-friendly" />
                </svg>
            )}
            {isCampaignProduct && (
                <svg className="image-tag image-tag--bottom" viewBox="0 0 54 15">
                    <rect x=".375" y=".375" width="53.25" height="14.25" rx="2.625" fill="#f04124" stroke="#404040" strokeWidth=".75" />
                    <text style={{ font: '9px Arial', fill: '#FFFFFF', textTransform: 'uppercase' }} x="26.62" y="10" textAnchor="middle">
                        {translate('product.campaignbanner')}
                    </text>
                </svg>
            )}
        </div>
    );
};

export default ProductTags;
